import { render, staticRenderFns } from "./paneldynamic-add-btn.vue?vue&type=template&id=247e54cb&"
import script from "./paneldynamic-add-btn.vue?vue&type=script&lang=ts&"
export * from "./paneldynamic-add-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247e54cb')) {
      api.createRecord('247e54cb', component.options)
    } else {
      api.reload('247e54cb', component.options)
    }
    module.hot.accept("./paneldynamic-add-btn.vue?vue&type=template&id=247e54cb&", function () {
      api.rerender('247e54cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/paneldynamic-actions/paneldynamic-add-btn.vue"
export default component.exports